export default "__VITE_ASSET__ByHUOIH7__"